import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ComplementosPagoCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SERIES = process.env.REACT_APP_URL_SERIES;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COMP_PAGO = process.env.REACT_APP_URL_COMP_PAGO;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  
  const [timbresDisponibles, setTimbresDisponibles] = useState(0);
  // cuentasClientes removido: el complemento ya no requiere cuenta del cliente
  // cuentasEmpresas removido: el complemento ya no requiere cuenta de empresa

  const [total, setTotal] = useState(0);

  const [facturas, setFacturas] = useState([]);

  const [clientes, setClientes] = useState([]);
  // const [cuentasClientes, setCuentasClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  // Objeto del cliente elegido en el Autocomplete (MUI necesita el objeto,
  // no el id) para poder buscar escribiendo cualquier parte del nombre.
  const [valueCliente, setValueCliente] = useState(null);
  // const [selectedCuentaCliente, setSelectedCuentaCliente] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");


  const [cpEmpresa, setCpEmpresa] = useState("");
  const [rfcEmpresa, setRfcEmpresa] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [regFiscalEmpresa, setRegFiscalEmpresa] = useState("");


  const [serie, setSerie] = useState("COMP")
  // Banco donde entra el pago (igual que AbonosCreate) — crea el MovimientoBanco al guardar
  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState("");

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
    .get(`${URL_CLIENTES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_SERIES}Timbres`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allTimbres = res.data;
          setTimbresDisponibles(allTimbres[0].folio);
        })
        .catch((err) => {
          console.log(err);
        });
     
      axios
      .get(`${URL_EMPRESAS}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allEmpresas = res.data;
          setEmpresas(allEmpresas);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
        .get(`${URL_COLABORADORES}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allColaboradores = res.data;
            setColaboradores(allColaboradores);
          })
          .catch((err) => {
            console.log(err);
          });

        axios
          .get(URL_BANCOS, {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          })
          .then((res) => setBancos(res.data || []))
          .catch((err) => console.log(err));
  }, [inputFields]);

  const saveComplemento = async (event) => {
    event.preventDefault();
    if (timbresDisponibles <= 0) {
      Swal.fire({
        icon: "error",
        title: "Sin timbres",
        text: "No cuenta con timbres disponibles",
      });
      return;
    }

    const conf = await Swal.fire({
      title: "Estas seguro?",
      text: "Se timbrará el complemento",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, timbrar!",
    });
    if (!conf.isConfirmed) return;

    if (total <= 0 || selectedBanco === "") {
      Swal.fire({ icon: "error", title: "Faltan Datos", text: "Total o banco vacío" });
      return;
    }

    setValidaBoton(false);
    toggleProgreso();

    // Flujo ATÓMICO: el back timbra primero y solo si el PAC responde active
    // crea CompPago, PagosFacturas, actualiza Facturas, crea MovimientoBanco.
    // Si algo falla NO queda nada sucio en la BD.
    try {
      const facturasPayload = inputFields
        .filter((w) => Number(w.impPagar) > 0 && w.facturas)
        .map((w) => ({ _id: w.facturas, importe: Number(w.impPagar) }));

      const { data } = await axios.post(
        `${URL_TIMBRAR}CompPagoAtomic`,
        {
          fecha,
          clientes: selectedCliente,
          colaboradores: selectedColaborador,
          empresas: selectedEmpresa,
          observaciones,
          serie,
          cfdiUse: "CP01",
          paymentForm: formaPagoSAT,
          currency: "MXN",
          bancos: selectedBanco,
          facturas: facturasPayload,
        },
        {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        }
      );

      // Log de auditoría (best-effort; no bloquea si falla)
      try {
        await axios.post(
          URL_LOGS,
          {
            tipo: "Crear Complemento de Pago",
            detalle: `Fecha ${fecha} · CompPago ${data?.compPago?.idCompPago || ""}`,
            user: user.id,
          },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
      } catch (_) { /* silencioso */ }

      Swal.fire("Good job!", "Complemento timbrado", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      const data = error?.response?.data;
      Swal.fire({
        icon: "error",
        title: "No se timbró",
        text: data?.message || "Error inesperado",
        footer: data?.facturama ? JSON.stringify(data.facturama).slice(0, 400) : undefined,
      });
      console.log(data || error);
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        facturas: "",
        idFactura: "",
        total: 0,
        abonos: 0,
        saldo: 0,
        impPagar: 0,
      },
    ]);
  };


  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let din = values.map((c) => parseFloat(c.impPagar));
    let TD = din.reduce((t, total, index) => t + total, 0);
    setTotal((TD).toFixed(2));
  };



  function BuscaCliente(event) {
    setSelectedCliente(event.target.value)

    setInputFields(
      [{
        id: uuidv4(),
        facturas: "",
        idFactura: "",
        total: 0,
        abonos: 0,
        saldo: 0,
        impPagar: 0,
      }]
      );

    clientes.map((a)=>{
      if(a._id == event.target.value){
      setFormaPagoSAT(a.formaPagoSAT)
      setSelectedColaborador(a.vendedor[0]._id)

      if(event.target.value != ""  && selectedEmpresa != ""){
        axios
        .get(`${URL_FACTURAS}CompPago/${event.target.value}/${selectedEmpresa}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allFacturas = res.data;
            let arrayTabla = allFacturas.map((a)=>{
              return {
                id: uuidv4(),
                facturas: a._id,
                idFactura: a.folio,
                total: a.total,
                abonos: a.abonos,
                saldo: Number(parseFloat(a.saldo).toFixed(2)), // Convertimos de nuevo a número
                impPagar: Number(parseFloat(a.saldo).toFixed(2)), // Convertimos de nuevo a número
              }
            })
            let dataFinal = Object.values(arrayTabla);
            setFacturas(dataFinal);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    })
  }

  function BuscaEmpresa(event) {
    setSelectedEmpresa(event.target.value)

    empresas.map((a)=>{
      if(a._id == event.target.value){
        setCpEmpresa(a.cp)
        setRfcEmpresa(a.rfc)
        setNombreEmpresa(a.razonSocial)
        setRegFiscalEmpresa(a.regimenFiscal)
      }
    })
    setInputFields(
    [{
      id: uuidv4(),
      facturas: "",
      idFactura: "",
      total: 0,
      abonos: 0,
      saldo: 0,
      impPagar: 0,
    }]
    );
    if(event.target.value != "" && selectedColaborador != "" && selectedCliente != ""){
      axios
      .get(`${URL_FACTURAS}CompPago/${selectedCliente}/${event.target.value}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allFacturas = res.data;
          let arrayTabla = allFacturas.map((a)=>{
            return {
              id: uuidv4(),
              facturas: a._id,
              idFactura: a.folio,
              total: a.total,
              abonos: a.abonos,
              saldo: a.saldo,
              impPagar: a.saldo,
            }
          })
          let dataFinal = Object.values(arrayTabla);
          setFacturas(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function BuscaColaborador(event) {
    setSelectedColaborador(event.target.value)
    setInputFields(
    [{
      id: uuidv4(),
      facturas: "",
      idFactura: "",
      total: 0,
      abonos: 0,
      saldo: 0,
      impPagar: 0,
    }]
    );
    if(event.target.value != "" && selectedCliente != "" && selectedEmpresa != ""){
      axios
      .get(`${URL_FACTURAS}CompPago/${selectedCliente}/${selectedEmpresa}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allFacturas = res.data;
          let arrayTabla = allFacturas.map((a)=>{
            return {
              id: uuidv4(),
              facturas: a._id,
              idFactura: a.folio,
              total: a.total,
              abonos: a.abonos,
              saldo: a.saldo,
              impPagar: a.saldo,
            }
          })
          let dataFinal = Object.values(arrayTabla);
          // setFacturas(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function BuscaFactura(id, event) {
    if (
      inputFields.filter((e) => e.facturas == event.target.value).length >
      0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El articulo ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.facturas = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    } else {
      facturas.map((a) => {
        if (a.facturas == event.target.value) {
          let facturas = a.facturas;
          let idFactura = a.idFactura;
          let total = a.total
          let abonos = a.abonos
          let saldo = a.saldo.toFixed(2)
          handleChangeInputArticulo(id, facturas, idFactura, total, abonos, saldo);
        }
      });
    }
  }

  const handleChangeInputArticulo = (id, facturas, idFactura, total, abonos, saldo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.facturas = facturas;
        i.idFactura = idFactura;
        i.abonos = abonos
        i.saldo = saldo
        i.total = total
        i.impPagar = saldo
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

function ActualizaTotales(fields) {
  const data = fields || inputFields; // Si no se pasa, usa el estado actual

  const din = data.map((c) => parseFloat(c.impPagar) || 0);
  const TD = din.reduce((t, total) => Math.round((t + total) * 100) / 100, 0);

  setTotal(TD.toFixed(2));
}




const handleChangeInput = (id, event) => {
  let value = event.target.value;

  // Convertimos el valor a número solo si no está vacío
  const numericValue = value === '' ? '' : parseFloat(value);

  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      if (value === '' || (!isNaN(numericValue) && numericValue <= i.saldo)) {
        return { ...i, impPagar: value === '' ? '' : numericValue };
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El Pago excede el Saldo!",
          showConfirmButton: false,
        });
      }
    }
    return i;
  });

  setInputFields(newInputFields);
  ActualizaTotales(newInputFields); // Calcula el total con los datos actualizados
};



  
  

  return (
    <>
      <Header />
      <br />
      <br />
      {user.compPagosFiscal ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Complemento de Pago</h3>
          <Form onSubmit={saveComplemento}>
          <Row>
            <Col md={2}>
                <Label>Timbres Disponibles</Label>
                <Input
                  type="text"
                  value={timbresDisponibles}
                  required
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(event) => {
                    setFecha(event.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Empresa</Label>
                    <Input
                      name="empresa"
                      type="select"
                      value={selectedEmpresa}
                      required
                      onChange={(event) => {
                        BuscaEmpresa(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {empresas
                        .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        if(a.listoFacturar == "Si" && a.is_active == "Si"){
                          return (
                            <option value={a._id}>{a.name}</option>
                          );}
                      })}
                    </Input>
                  </Col>

                  <Col md={3}>
                <Label>Cliente</Label>
                    {/* Autocomplete en vez de select: el select sólo empata
                        desde la primera letra, y muchas veces uno recuerda la
                        segunda palabra del nombre ("toro" de "Refaccionaria
                        Toro"). Aquí busca por cualquier parte del nombre. */}
                    <Autocomplete
                      size="small"
                      value={valueCliente}
                      options={clientes.sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )}
                      getOptionLabel={(o) => o.nombre_comercial || ""}
                      getOptionSelected={(o, v) => o._id === (v && v._id)}
                      onChange={(_, v) => {
                        setValueCliente(v);
                        // BuscaCliente sigue esperando un evento: se le arma
                        // uno sintético para no tocar toda su lógica.
                        BuscaCliente({ target: { value: v ? v._id : "" } });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona un Cliente"
                          variant="outlined"
                        />
                      )}
                    />
                  </Col>

                  <Col md={3}>
                <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaborador}
                      required
                      onChange={(event) => {
                        BuscaColaborador(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colaboradores
                        .sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre} {a.apellido} </option>
                          );
                      })}
                    </Input>
                  </Col>
</Row>
<Row>
                  <Col md={3}>
                    <Label>Banco</Label>
                    <Input
                      type="select"
                      value={selectedBanco}
                      required
                      onChange={(event) => setSelectedBanco(event.target.value)}
                    >
                      <option value="">Selecciona un Banco</option>
                      {bancos
                        .filter((b) => b.is_active !== "No")
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((a) => (
                          <option key={a._id} value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        ))}
                    </Input>
                  </Col>
             <Col md={3}>
                <Label>Forma Pago</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  required
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>
             </Row>

             <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Factura</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Abonos</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Saldo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Importe a Pagar</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="facturas"
                      type="select"
                      value={inputField.facturas}
                      required
                      onChange={(event) => {
                        BuscaFactura(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {facturas
                      .sort((a, b) => (a.idFactura > b.idFactura ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a.facturas}>
                            {a.idFactura}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.total}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="abonos"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.abonos}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="saldo"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.saldo}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="impPagar"
                      type="number"
                      min="0"
                      step="0.01"
                      value={inputField.impPagar}
                      onChange={(e) => {
                        handleChangeInput(inputField.id, e);
                      }}
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            <br />
            <Row>
           
            <Col md={3}>
            <Label className="mr-sm-2">Total</Label>
            <Input
              type="number"
              value={total}
              disabled
            />
            </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoComplementosPago"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComplementosPagoCreate;
